import React, { useState, useEffect } from 'react';
import { XMarkIcon, MagnifyingGlassIcon } from '@heroicons/react/24/solid';

const ANIM_DURATION_MS = 250;

const SearchBar = ({ value, onChange, onClose, count }) => {
  const [isExiting, setIsExiting] = useState(false);
  const [hasEntered, setHasEntered] = useState(false);

  useEffect(() => {
    const t = requestAnimationFrame(() => {
      requestAnimationFrame(() => setHasEntered(true));
    });
    return () => cancelAnimationFrame(t);
  }, []);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => onClose(), ANIM_DURATION_MS);
  };

  return (
    <div
      className={`sticky top-14 z-10 bg-white border-b border-gray-200 shadow-sm rounded-b-xl px-3 py-2 flex flex-col gap-2 transition-transform duration-[250ms] ease-out overflow-hidden ${
        hasEntered && !isExiting ? 'translate-y-0' : '-translate-y-full'
      }`}
    >
      <div className="flex items-center gap-2">
        <MagnifyingGlassIcon className="h-5 w-5 text-gray-400 flex-shrink-0" />
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Buscar em título e conteúdo..."
          className="flex-1 min-w-0 py-2 px-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-transparent"
          autoFocus
        />
        <button
          type="button"
          onClick={handleClose}
          className="p-2 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-gray-700 flex-shrink-0"
          title="Fechar busca"
        >
          <XMarkIcon className="h-5 w-5" />
        </button>
      </div>
      <p className="text-xs text-gray-500">
        {count === 0
          ? 'Nenhuma nota encontrada'
          : count === 1
            ? '1 nota encontrada'
            : `${count} notas encontradas`}
      </p>
    </div>
  );
};

export default SearchBar;
